export class PrintDeliveryDetailsCommand {
  serviceProviderName: string;
  serviceProviderAddressStreet: string;
  serviceProviderAddressNumber: string;
  serviceProviderAddressAp: string;
  serviceProviderAddressZip: string;
  serviceProviderAddressRegion: string;
  appartament?: string;
  block?: string;
  cityName?: string;
  countryName?: string;
  regionName?: string;
  streetName?: string
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  carrierName: string[];
  carrierPrice: number[] | null;
  zipCode?: string;
  provinceCode?: string;
  carrierEndDate: Date[];
  products: Array<ProductPrint> = new Array<ProductPrint>();
}
export class ProductPrint {
  name: string;
  price: number;
  code: string;
}